import React from 'react';
import { getDateString } from '../../../../../ui-toolkit/utilities/getDateString';
import { SummaryItem } from '../../../../shared/Summary/SummaryItem/SummaryItem';
import { useSelectCurrentOrder } from '../../../../../selectors/order/selectCurrentOrder';

export const OrderOpened: React.FC = () => {
  const { data } = useSelectCurrentOrder();

  return (
    <SummaryItem label={`Order Opened`} tab={'summary'}>
      {getDateString(`LLLL d, yyyy`, data.orderInformation.created, true)}
      {data.orderInformation.createdBy ? ` by ${data.orderInformation.createdBy}` : ``}
    </SummaryItem>
  );
};
